import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Match } from '../../../models';
import { MatSlideToggleChange } from '@angular/material';

@Component({
  selector: 'match-info',
  templateUrl: './match-info.component.html',
  styles: []
})
export class MatchInfoComponent implements OnInit {

  @Input() match: Match;
  @Output() readonly publishChanged = new EventEmitter<boolean>();
  @Output() readonly republish = new EventEmitter();

  ngOnInit(): void {
    console.info('[MatchInfoComponent] init: ', this.match);
  }

  onPublishChanged(result: MatSlideToggleChange) {
    console.info('[MatchInfoComponent] publishChange: ', result, this.match);
    this.publishChanged.emit(result.checked);
  }

  onRepublish() {
    console.info('[MatchInfoComponent] republish: ');
    this.republish.emit(true);
  }
}
